import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

const StyledLocalLink = styled.span`
  display: inline-block;

  text-decoration: none;
  border-bottom: 1px solid
    ${({ theme }) => (theme.linkUnderlined ? theme.colors.link : "transparent")};
  padding-bottom: 4px;
  cursor: pointer;

  .forward-chevron {
    display: ${({ theme }) =>
      theme.forwardLinkHasChevron ? "inline-block" : "none"};
  }

  .back-chevron {
    display: ${({ theme }) =>
      theme.backLinkHasChevron ? "inline-block" : "none"};
  }

  img:first-child {
    transform: rotate(180deg);
    margin-right: ${({ theme }) => theme.linkChevronMargin};
  }

  img:last-child {
    margin-left: ${({ theme }) => theme.linkChevronMargin};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.link};
    margin-top: 24px;
  }

  a ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary2};
  }
`;

export default StyledLocalLink;
